import { SVGProps } from 'react'

export const FourTilesThickIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={15} height={14} fill="currentColor" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1.633 0a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h3.903a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1H1.633Zm0 8a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h3.903a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1H1.633Zm6.872-7a1 1 0 0 1 1-1h3.903a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H9.505a1 1 0 0 1-1-1V1Zm1 7a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h3.903a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1H9.505Z"
      clipRule="evenodd"
    />
  </svg>
)

export default FourTilesThickIcon
